import PlanProduct from ".";

export const planRoutes = () => [
  {
    path: "/admin/plan-product",
    title: "plans",
    layout: "admin",
    routeType: "admin",
    component: PlanProduct,
  },
];
